export { default as styled } from './styles/styled';
export const dummy = true;
